/* Frute only: illustrative touch game; native Shopify variant/cart code remains authoritative. */
(() => {
  const instances = new WeakMap();
  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController(), signal = controller.signal;
    const listen = (target, type, fn) => target?.addEventListener(type, fn, { signal });
    const sim = root.querySelector('[data-frute-simulator]');
    const status = sim?.querySelector('[data-frute-status]');
    const pads = [...(sim?.querySelectorAll('[data-frute-pad]') || [])];
    const touch = sim?.querySelector('[data-frute-touch]');
    const sound = sim?.querySelector('[data-frute-sound]');
    const stage = sim?.querySelector('.wf-sim-stage');
    let held = [false, false], soundOn = false, count = 0, context, releaseTimer;
    const notes = [261.63, 293.66, 329.63, 392, 440, 392, 329.63, 293.66];
    function sync() {
      pads.forEach((pad, i) => pad.setAttribute('aria-pressed', String(held[i])));
      if (touch) touch.disabled = !held.every(Boolean);
      if (status) status.textContent = held.every(Boolean) ? 'الطرفان ممسوكان. جرّب لمسة بين اللاعبين.' : held.some(Boolean) ? 'بقي الطرف الآخر. فعّله ليشارك اللاعب الثاني.' : 'فعّل الطرفين ليمسك كل لاعب طرفًا.';
    }
    function stopAudio() {
      if (context?.state === 'running') context.suspend().catch(() => {});
    }
    function note(frequency) {
      if (!soundOn) return;
      try {
        const Audio = window.AudioContext || window.webkitAudioContext;
        if (!Audio) throw new Error('unsupported');
        context ||= new Audio();
        const play = () => {
          if (!soundOn || document.hidden) return;
          const oscillator = context.createOscillator(), gain = context.createGain(), time = context.currentTime;
          oscillator.type = 'sine'; oscillator.frequency.setValueAtTime(frequency, time);
          gain.gain.setValueAtTime(0, time); gain.gain.linearRampToValueAtTime(.11, time + .012); gain.gain.exponentialRampToValueAtTime(.001, time + .32);
          oscillator.connect(gain); gain.connect(context.destination); oscillator.start(time); oscillator.stop(time + .34);
          oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
        };
        if (context.state !== 'running') context.resume().then(play).catch(() => { soundOn = false; sound?.setAttribute('aria-pressed', 'false'); }); else play();
      } catch {
        soundOn = false; if (sound) { sound.setAttribute('aria-pressed', 'false'); sound.textContent = 'الصوت غير متاح في هذا المتصفح'; }
      }
    }
    pads.forEach((pad, i) => listen(pad, 'click', () => { held[i] = !held[i]; count = 0; sync(); }));
    listen(touch, 'click', () => {
      if (!held.every(Boolean)) return;
      note(notes[count % notes.length]); count++;
      status.textContent = `لمسة ${count}. جرّب إيقاعك!`;
      stage.classList.add('is-playing'); clearTimeout(releaseTimer);
      releaseTimer = setTimeout(() => stage.classList.remove('is-playing'), 160);
    });
    listen(sound, 'click', () => {
      soundOn = !soundOn; sound.setAttribute('aria-pressed', String(soundOn));
      sound.textContent = soundOn ? 'كتم صوت التجربة' : 'تفعيل صوت التجربة';
      if (soundOn) note(329.63); else stopAudio();
    });
    listen(sim?.querySelector('[data-frute-reset]'), 'click', () => { held = [false, false]; count = 0; stage.classList.remove('is-playing'); sync(); stopAudio(); });
    const select = root.querySelector('[data-child-variant]');
    function syncPacks() {
      const option = select?.selectedOptions[0];
      root.querySelectorAll('[data-frute-pack]').forEach(image => { image.src = option?.dataset.fruteCutout || option?.dataset.image || image.src; image.removeAttribute('srcset'); });
    }
    listen(select, 'change', syncPacks); syncPacks();
    root.querySelectorAll('[data-frute-choose]').forEach(button => {
      const option = [...(select?.options || [])].find(o => o.dataset.fruteKey === button.dataset.fruteChoose);
      button.disabled = !option || option.dataset.available !== 'true';
      if (button.disabled) button.textContent = 'غير متاح حاليًا';
      listen(button, 'click', () => {
        if (button.disabled || !option) return;
        select.value = option.value; select.dispatchEvent(new Event('change', { bubbles: true }));
        const form = root.querySelector('[data-child-form]');
        form?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        form?.setAttribute('tabindex', '-1'); form?.focus({ preventScroll: true });
      });
    });
    const video = root.querySelector('[data-frute-video]'), play = root.querySelector('[data-frute-video-play]'), videoSound = root.querySelector('[data-frute-video-sound]');
    let userPaused = false;
    const playVideo = () => { video?.play().catch(() => { if (play) play.textContent = 'تشغيل'; }); };
    listen(play, 'click', () => { if (video.paused) { userPaused = false; playVideo(); } else { userPaused = true; video.pause(); } });
    listen(video, 'play', () => { play.textContent = 'إيقاف'; play.setAttribute('aria-label', 'إيقاف الفيديو'); });
    listen(video, 'pause', () => { play.textContent = 'تشغيل'; play.setAttribute('aria-label', 'تشغيل الفيديو'); });
    listen(videoSound, 'click', () => { video.muted = !video.muted; videoSound.setAttribute('aria-pressed', String(!video.muted)); videoSound.textContent = video.muted ? 'تفعيل الصوت' : 'كتم الصوت'; if (!video.muted && video.paused) { userPaused = false; playVideo(); } });
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting && !userPaused && !document.hidden && !matchMedia('(prefers-reduced-motion: reduce)').matches) playVideo();
      else video?.pause();
    }), { threshold: .3 });
    if (video) observer.observe(video);
    listen(document, 'visibilitychange', () => { if (document.hidden) { video?.pause(); stopAudio(); } });
    listen(window, 'pagehide', () => { video?.pause(); stopAudio(); });
    instances.set(root, () => { controller.abort(); observer.disconnect(); video?.pause(); clearTimeout(releaseTimer); context?.close().catch(() => {}); instances.delete(root); });
    root.dataset.fruteReady = 'true';
  }
  const scan = scope => { if (scope.matches?.('[data-frute-page]')) init(scope); scope.querySelectorAll?.('[data-frute-page]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true }); else scan(document);
  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-frute-page]').forEach(root => instances.get(root)?.()));
})();
